import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpClient from 'services/HttpClient';
import { getUserToken } from 'services/utils';
import { getBaseNewURL } from 'services/getBaseURL';

const http = new HttpClient();
const baseURL = getBaseNewURL().base;
const initialState = {
	wallets: null,
	message: '',
	loading: {
		backdrop: false,
		form: false,
		skeleton: false,
		input: false,
	},
};

// getWallet
export const GetWalletHome = createAsyncThunk('/GetWalletHome', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {};
	const response = await http

		.post(`${baseURL}/Wallets`, param, { headers: extraConfig.headers })
		.then((res) => res.data);
	return response;
});

const HomeWalletSlice = createSlice({
	name: 'walletHome',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(GetWalletHome.pending, (state) => {
				state.loading.skeleton = true;
			})
			.addCase(GetWalletHome.fulfilled, (state, action) => {
				state.loading.skeleton = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.wallets = Content.Wallets || [];
				} else {
					state.message = Message;
				}
			})
			.addCase(GetWalletHome.rejected, (state) => {
				state.loading.skeleton = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			});
	},
});

// export const {} = HomeWalletSlice.actions;
export default HomeWalletSlice.reducer;
